import { AccountData } from "./AccountData";

export class ClientAccount {
  public clientCd: string;
  public clientName: string;
  public accounts: Array<AccountData> = [];
}
